<template>

    <teleport to="body">
        <transition name="modal-fade">
            <div v-if="open" class="modal-overlay" @click.self="close()">
                <div class="modal-window" :style="{ 'max-width': width + 'px' }" role="dialog" aria-modal="true">
                    <div class="modal-header">
                        <div class="modal-title">
                            <AppIcon v-if="icon" :name="icon" class="modal-title-icon"/>
                            <span>{{ title }}</span>
                        </div>
                        <button type="button" class="modal-close" @click="close()" aria-label="Закрыть">
                            <AppIcon name="x" class="modal-close-icon"/>
                        </button>
                    </div>
                    <div class="modal-body">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </transition>
    </teleport>

</template>


<script>

import AppIcon from './AppIcon.vue';

export default {
    name: 'ModalUI',

    components: {
        AppIcon
    },

    props: {
        open: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
        },
        width: {
            type: Number,
            default: 480
        }
    },

    watch: {
        open(val) {
            if (val) {
                document.addEventListener('keydown', this.onKey);
            } else {
                document.removeEventListener('keydown', this.onKey);
            }
        }
    },

    methods: {
        close() {
            this.$emit('close');
        },

        onKey(e) {
            if (e.key === 'Escape'){
                this.close();
            }
        }
    },

    beforeUnmount() {
        document.removeEventListener('keydown', this.onKey);
    }
}

</script>


<style scoped>

.modal-overlay{
    position: fixed;
    inset: 0;
    z-index: 100;

    display: flex;
    align-items: flex-start;
    justify-content: center;

    padding: 10vh 16px 16px;

    background: rgba(0, 0, 0, 0.5);
}

.modal-window{
    width: 100%;

    background: var(--card);
    border: 1px solid var(--border);
    border-radius: 12px;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);

    overflow: hidden;
}

.modal-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;

    padding: 16px 20px;

    border-bottom: 1px solid var(--border);
}

.modal-title{
    display: flex;
    align-items: center;
    gap: 8px;

    font-size: 15px;
    font-weight: 600;
}

.modal-title-icon{
    width: 16px;
    height: 16px;

    color: var(--muted-foreground);
}

.modal-close{
    display: inline-flex;
    align-items: center;
    justify-content: center;

    width: 30px;
    height: 30px;

    background: transparent;
    border: none;
    border-radius: 8px;
    color: var(--muted-foreground);

    cursor: pointer;

    transition: background-color 0.15s ease, color 0.15s ease;
}

.modal-close:hover{
    background: var(--muted);
    color: var(--foreground);
}

.modal-close-icon{
    width: 16px;
    height: 16px;
}

.modal-body{
    padding: 20px;
}

.modal-fade-enter-active,
.modal-fade-leave-active{
    transition: opacity 0.15s ease;
}

.modal-fade-enter,
.modal-fade-leave-to{
    opacity: 0;
}

</style>
